import { Card, Typography, Stack, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";

export function FruitCalibrationLegend(): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: "absolute",
        top: { xs: 16, md: 24 },
        left: { xs: 16, md: 24 },
        zIndex: 20,
        pointerEvents: "auto",
      }}
    >
      <Card
        sx={{
          p: 1.5,
          boxShadow: "0 4px 12px var(--color-shadow)",
          borderRadius: 2,
          bgcolor: "var(--color-surface)",
          backdropFilter: "blur(4px)",
          minWidth: 120,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mb: 1,
            color: "text.secondary",
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }}
        >
          {t("heading.calibrate.classes")}
        </Typography>
        <Stack spacing={0.75}>
          {[...Array(5)].map((_, index) => (
            <Stack
              key={t(`label.calibrate.yield.category-${index}`)}
              direction="row"
              alignItems="center"
              spacing={1.5}
            >
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "3px",
                  bgcolor: `var(--color-apple-calibration-map-${index})`,
                  boxShadow: "inset 0 0 0 1px var(--color-shadow)",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: "0.8rem",
                  color: "text.primary",
                }}
              >
                {t(`label.calibrate.yield.short.category-${index}`)}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Card>
    </Box>
  );
}
